export const API_BASE_URL =
process.env.NODE_ENV === 'development'
  ? 'http://localhost:3005/api/v1'
  : 'https://cp.exiniti.com/api/v1';

export const CP_URL =  
process.env.NODE_ENV === 'development'
  ? 'http://localhost:3010'
  : 'https://cp.exiniti.com';

export const CP_GATE =
process.env.NODE_ENV === 'development'
  ? 'http://localhost:3010/Gate'
  : 'https://cp.exiniti.com/Gate';

export const DEPOSIT_API_BASE_URL = 'https://engine-psp-service.azurewebsites.net'